import React from "react";

export default function Loading() {
  return (
    <p style={{ display: "flex", alignItems: "center" }}>
      <img src={"/img/ui/spinner.gif"} alt={"spinner"} />
      <span>loading...</span>
    </p>
  );
}
